import { createGlobalStyle } from 'styled-components'

import '@hotmart/cosmos/dist/styles/reset.css'
import '@hotmart/cosmos/dist/styles/base.css'
import '@hotmart/cosmos/dist/styles/theme.css'

const GlobalStyles = createGlobalStyle`
  html {
    /* Layout */
    --body-max-size: 67.5rem;
    --cosmos-nav-width: 4.3125rem;
    --body-padding: 3rem;
    --anchor-sidebar-nav-width: 15.125rem;

    /* Colors */
    --light-background: #F5F6F7;
    --danger: #e74c3c;
    --success: #2ecc71;

    /* Z-index */
    --zindex-floating-button: 2;
    --zindex-modal: 1055;

    /* Cosmos rules */
    --cosmos-transition-time: var(--timing, 0.5s) var(--easing, 0.5s);

    /* Anchor */
    --anchor-padding-left: 12.5rem;
  }
`

export default GlobalStyles
